import { graphql } from "react-relay";

export const GENERATE_APP_JWT_AUTH_VIEWER_SCHEMA_FRAGMENT = graphql`
	fragment generateAppJwt_AuthViewerSchemaFragment on AuthViewerSchema {
		currentUser {
			user {
				id
			}
			accounts {
				id
			}
		}
	}
`;
